<template>
  <div class="app-container">
    <component :is="currentList" :orders="orders"></component>
  </div>
</template>

<script>
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { selectCarAndUserRel, getStopCarInfo } from '@/api/park'
import { deepClone, getUrlParam, getTimeval, parseTime } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'My-Order',
  components: { Available, Unavailable },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token'])
  },
  created () {
    this.handleFilter()
  },
  data () {
    return {
      defultCarNumber: null, //默认车牌
      currentList: 'Unavailable',
      orders: []
    }
  },
  methods: {
    //查询绑定车牌
    handleFilter () {
      let _this = this
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let params = {
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : ''
      }
      selectCarAndUserRel(params)
        .then(response => {
          let data = response.body
          getInfo_Loading.clear()
          _this.defultCarNumber = null
          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            if (element.isDefaultCar) {
              _this.defultCarNumber = element.cardNumber
            }
          }
          if (!_this.defultCarNumber) {
            _this.$store.dispatch('app/setBackflow', _this.$options.name)
            _this.$router.push({ name: 'My-Car' })
          } else {
            _this.componentsValve()
          }
        })
        .catch(error => {
          getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    componentsValve () {
      let _this = this
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let cardNumberAsParams = _this.$route.query.cardNumber
      let params = {
        cardNumber: cardNumberAsParams || _this.defultCarNumber,
        parkId: getUrlParam("parkId") || _this.$route.query.parkId || null,
      }
      getStopCarInfo(params)
        .then(response => {
          getInfo_Loading.clear()
          let data = response.body
          if (data.entranceDate) {
            let exitDate = data.exitDate || parseTime(new Date())
            data.parkingTime = getTimeval(data.entranceDate, exitDate)
          }
          if (Object.keys(data).length > 0) {
            _this.orders = deepClone(data)
            _this.currentList = 'Available'
          } else {
            _this.currentList = 'Unavailable'
          }
        })
        .catch(error => {
          getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    }
  }
}
</script>